module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon18.61146392.png";